"use client";

import * as React from "react";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { copyToClipboard } from "@/utils/clipboard";

interface CopyButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    value: string;
    src?: string;
    event?: string;
}

export function CopyButton({
    value,
    className,
    src,
    event,
    ...props
}: CopyButtonProps) {
    const [hasCopied, setHasCopied] = React.useState(false);

    React.useEffect(() => {
        if (hasCopied) {
            const timeout = setTimeout(() => setHasCopied(false), 2000);
            return () => clearTimeout(timeout);
        }
    }, [hasCopied]);

    return (
        <Button
            type="button"
            size="icon"
            variant="ghost"
            className={cn("size-8 text-muted-foreground hover:bg-muted hover:text-foreground", className)}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                void copyToClipboard(value)
                    .then(() => setHasCopied(true))
                    .catch(() => setHasCopied(false));
            }}
            {...props}
        >
            <span className="sr-only">Copy</span>
            {hasCopied ? (
                <IconCheck className="size-3" />
            ) : (
                <IconCopy className="size-3" />
            )}
        </Button>
    );
}